import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  InputGroup,
  Card,
  Spinner,
} from "react-bootstrap";
import { FaUser, FaPhone, FaEnvelope, FaLock } from "react-icons/fa";
import logo from "../../../assets/images/TrustiDrivelogo.png";
import "../../../assets/css/Drivers/DriverAuth/Driversignup.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const Driversignup = () => {
  const { baseUrl, RegExpChecker, formatPhoneNumber } = useContext(AppContext);

  const [drivername, setdriverName] = useState("");
  const [driverEmail, setdriverEmail] = useState("");
  const [driverphone, setdriverPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
  });

  const navigate = useNavigate();

  const isFormValid =
    drivername &&
    driverEmail &&
    driverphone &&
    password &&
    !errors.username &&
    !errors.email &&
    !errors.phone &&
    !errors.password;

  // Ek hi jagah se field ka error set karne ke liye helper
  const validateField = (field, type, value) => {
    const regError = RegExpChecker(type, value);
    setErrors((prev) => ({
      ...prev,
      [field]: value && regError ? regError : "",
    }));
  };

  const handleSignup = () => {
    // Pehle validity check, phir loading true (pehle ulta tha, is se button atak jata tha)
    if (!isFormValid) return;
    setLoading(true);

    const formdata = new FormData();
    formdata.append("drivername", drivername.trim());
    formdata.append("driverEmail", driverEmail.trim());
    formdata.append("driverphone", driverphone);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/driver/profile/createDriver`, formdata)
      .then((response) => {
        setLoading(false);

        if (response.data.hasOwnProperty("error")) {
          // Error par form clear nahi hota, user dobara sab kuch na likhe
          alert("Error: " + response.data.error);
        } else {
          setdriverName("");
          setdriverEmail("");
          setdriverPhone("");
          setPassword("");
          alert("Account Created Successfully!");
          navigate("/identity-verification");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <Container fluid className="Driver-signup-wrapper">
      <Row className="Driver-signup-row">
        <Col xs={12} className="Driver-signup-col">
          <Card className="Driver-signup-card border-0">
            <Card.Body className="Driver-signup-card-body">
              {/* Logo */}
              <div className="text-center Driver-signup-logo-container">
                <img src={logo} alt="TrustiDrive" className="driverlogin-logo" />
              </div>

              {/* Heading */}
              <div className="text-center Driver-signup-header">
                <Card.Title as="h2" className="Driver-signup-title">
                  Create your account
                </Card.Title>
                <Card.Text className="Driver-signup-subtitle">
                  Explore your life by driving with{" "}
                  <span className="Driver-signup-brand">TrustiDrive</span>
                </Card.Text>
              </div>

              <Form
                className="Driver-signup-form"
                onSubmit={(e) => e.preventDefault()}
              >
                {/* USERNAME */}
                <Form.Group className="mb-3">
                  <Form.Label>User Name</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaUser />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={drivername}
                      placeholder="Enter your name"
                      onChange={(e) => {
                        const value = e.target.value;
                        setdriverName(value);
                        validateField("username", "username", value);
                      }}
                    />
                  </InputGroup>
                  {errors.username && (
                    <small className="text-danger">{errors.username}</small>
                  )}
                </Form.Group>

                {/* PHONE */}
                <Form.Group className="mb-3">
                  <Form.Label>Mobile Number</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaPhone />
                    </InputGroup.Text>
                    <Form.Control
                      type="tel"
                      inputMode="numeric"
                      value={driverphone}
                      placeholder="0300-9988998"
                      maxLength={12}
                      onChange={(e) => {
                        const formatted = formatPhoneNumber(e.target.value);
                        setdriverPhone(formatted);
                        validateField("phone", "phonenumber", formatted);
                      }}
                    />
                  </InputGroup>
                  {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                </Form.Group>

                {/* EMAIL */}
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaEnvelope />
                    </InputGroup.Text>
                    <Form.Control
                      type="email"
                      value={driverEmail}
                      placeholder="Enter you email"
                      onChange={(e) => {
                        const value = e.target.value;
                        setdriverEmail(value);
                        validateField("email", "email", value.trim());
                      }}
                    />
                  </InputGroup>
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </Form.Group>

                {/* PASSWORD */}
                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaLock />
                    </InputGroup.Text>
                    <Form.Control
                      type="password"
                      value={password}
                      placeholder="Enter Password"
                      onChange={(e) => {
                        const value = e.target.value;
                        setPassword(value);
                        validateField("password", "password", value);
                      }}
                    />
                  </InputGroup>
                  {errors.password && (
                    <small className="text-danger">{errors.password}</small>
                  )}
                </Form.Group>

                {/* BUTTON */}
                <div className="d-grid gap-2">
                  <Button
                    variant="success"
                    type="button"
                    size="lg"
                    className="Driver-signup-submit-btn"
                    onClick={handleSignup}
                    disabled={!isFormValid || loading}
                  >
                    {loading ? (
                      <div className="btn-content-wrapper">
                        <Spinner size="sm" animation="border" />
                        <span className="ms-2">Loading...</span>
                      </div>
                    ) : (
                      "Sign Up"
                    )}
                  </Button>
                </div>

                {/* SIGN IN */}
                <div className="text-center Driver-signup-footer">
                  <p>
                    Already have an account?{" "}
                    <Link
                      to="/Driver-login"
                      className="Driver-signup-footer-text-link"
                    >
                      Sign in
                    </Link>
                  </p>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Driversignup;